import { track, RECEIVE } from '@updater-core/lib/tracker';
import * as sessionMatchers from '../session/session.matchers';
import { getResponseHeaders } from '../session/session.epic';
import { SESSION_HEADERS } from '../../constants';
import { graphql } from '../../helpers';
import promotionFragment from '../../components/steps/promotions/app/store/fragments/promotion';
import entityInterfaceFragment from '../../components/steps/promotions/app/store/fragments/entity-interface';
import claimedPromotionFragment from '../../components/steps/promotions/app/store/fragments/claimed-promotion';
import gql from 'graphql-tag';
import * as selectors from './selectors';
import { ENVIRONMENT } from '../../environment';
import { handlePromotionClaimsAtSignUp } from './moverpass';
const SET_PROMOTIONS = 'SET_PROMOTIONS';
const CLAIM_PROMOTIONS = 'CLAIM_PROMOTIONS';
export const SHOW_SPLASH_PAGE = 'PROMOTIONS_SHOWN_SPLASH_PAGE';

let responseHeaders;

export function reducer(state = {}, action) {
  if (action.type === SET_PROMOTIONS) {
    return {
      ...state,
      eligiblePromotions: action.payload.eligiblePromotions,
      claimedPromotions: action.payload.claimedPromotions,
    };
  }

  if (action.type === SHOW_SPLASH_PAGE) {
    return {
      ...state,
      hasSeenSplashPage: true,
    };
  }

  return state;
}

export const actions = {
  setPromotions: (payload) => ({
    type: SET_PROMOTIONS,
    payload,
  }),
  claimPromotions: (ids, source) => (dispatch) =>
    claimPromotions(responseHeaders, ids, source).then(() =>
      fetchPromotionData(responseHeaders, dispatch, 'NormalizePromotionsState')
    ),
  hasSeenSplashPage: () => ({
    type: SHOW_SPLASH_PAGE,
  }),
  fetchPromotionsNow: () => (dispatch) =>
    fetchPromotionData(responseHeaders, dispatch, 'FetchPromotionsThunk'),
};

function fetchPromotionData(
  headers,
  dispatch,
  name = 'sessionCreateGetPromotions'
) {
  const query = gql`
    query ${name} {
      eligiblePromotions {
        eligiblePromotions {
          promotion {
            ...${promotionFragment.name}
          }
          validFor {
            ...${entityInterfaceFragment.name}
          }
        }
      }

      claimedPromotions {
        claimedPromotions {
          ...${claimedPromotionFragment.name}
        }
      }
    }

    ${promotionFragment.fragment}
    ${entityInterfaceFragment.fragment}
    ${claimedPromotionFragment.fragment}
  `;

  return graphql
    .fetchGraphQLQuery({
      headers,
      query,
      url: `${ENVIRONMENT.endpoints.api.url}/graphql`,
    })
    .then(({ data: { eligiblePromotions, claimedPromotions } }) => {
      track({
        domain: 'promotions',
        object: 'eligible_promotions',
        verb: RECEIVE,
        details: {
          eligiblePromotions: eligiblePromotions?.eligiblePromotions?.map(
            (promotion) => ({
              promotionId: promotion?.promotion?.id,
              promotionCode: promotion?.promotion?.code,
            })
          ),
        },
      });

      dispatch(
        actions.setPromotions({
          eligiblePromotions,
          claimedPromotions,
        })
      );
    });
}

function claimPromotions(headers, ids = [], source = 'exclusive_offers') {
  const query = gql`
  mutation ClaimPromotion($input: ClaimPromotionInput!) {
    claimPromotion(input: $input) {
      claimedPromotion {
        ...${claimedPromotionFragment.name}
      }
    }
  }
  ${claimedPromotionFragment.fragment}
  `;

  return Promise.all(
    ids.map((id) =>
      graphql.fetchGraphQLQuery({
        query,
        headers,
        url: `${ENVIRONMENT.endpoints.api.url}/graphql`,
        variables: {
          input: {
            promotionId: id,
            source,
          },
        },
      })
    )
  );
}

export function epic() {
  return (action, { dispatch }) => {
    if (
      sessionMatchers.isCreateSuccess(action) ||
      sessionMatchers.isReadSuccess(action)
    ) {
      responseHeaders = getResponseHeaders(
        action.meta.response,
        SESSION_HEADERS
      );

      handlePromotionClaimsAtSignUp(responseHeaders).then(() =>
        fetchPromotionData(responseHeaders, dispatch)
      );
    }

    if (action.type === SHOW_SPLASH_PAGE) {
      localStorage.setItem(SHOW_SPLASH_PAGE, true);
    }

    if (action.type === CLAIM_PROMOTIONS) {
      claimPromotions(responseHeaders, action.payload.ids).then(() =>
        fetchPromotionData(
          responseHeaders,
          dispatch,
          'NormalizePromotionsState'
        )
      );
    }
  };
}

export { selectors };
